import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpBaseService } from './http-base.service';
import {
    GraphicCreateDto, GraphicListDto, GraphicTemplateCreateDto, GraphicTemplateDetailDto,
    GraphicTemplateListDto, GraphicUpdateDto, GraphicDetailDto,
    GraphicTemplateUpdateNameDto,
    GraphicTemplateUpdateQueryDto
} from '../dtos';

@Injectable({
    providedIn: 'root'
})
export class GraphicService extends HttpBaseService {
    private readonly baseEndpoint = 'api/Graphics';

    /**
     * Get graphics by dashboard ID
     */
    getGraphicsByDashboard(dashboardId: string): Observable<GraphicListDto[]> {
        if (!dashboardId) {
            return of([]);
        }
        return this.get<GraphicListDto[]>(`${this.baseEndpoint}/dashboard/${dashboardId}`);
    }

    getGraphicById(graphicId: string): Observable<GraphicDetailDto> {
        return this.get<GraphicDetailDto>(`${this.baseEndpoint}/${graphicId}`);
    }

    /**
     * Create a new graphic
     * @returns Observable containing the created graphic's ID
     */
    createGraphic(graphic: GraphicCreateDto): Observable<{ id: string }> {
        return this.post<{ id: string }>(this.baseEndpoint, graphic);
    }

    /**
     * Update an existing graphic
     */
    updateGraphic(graphic: GraphicUpdateDto): Observable<void> {
        return this.put<void>(this.baseEndpoint, graphic);
    }

    /**
     * Delete a graphic
     */
    deleteGraphic(graphicId: string): Observable<void> {
        return this.delete<void>(`${this.baseEndpoint}/${graphicId}`);
    }



}